// src/pages/Auth/SignupForm.jsx

import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import styles from './AuthForm.module.css';
import { useNavigate } from 'react-router-dom';
import { showSuccess, showError } from '../../../../components/ModernSnackbar';
import { signup } from '../../../../services/api/fytnServices';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

// Password validation schema
const passwordSchema = yup
  .string()
  .required('Password is required')
  .min(8, 'Minimum 8 characters')
  .matches(/[A-Z]/, 'Must include one uppercase letter')
  .matches(/[a-z]/, 'Must include one lowercase letter')
  .matches(/[0-9]/, 'Must include one number')
  .matches(/[@$!%*#?&]/, 'Must include one special character');

// Signup schema
const signupSchema = yup.object().shape({
  name: yup.string().required('Username is required'),
  email: yup.string().email('Invalid email').required('Email is required'),
  password: passwordSchema,
});

const SignupForm = () => {
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(signupSchema),
  });

  const onSubmit = async (data) => {
    try {
      const res=await signup(data);
      console.log("res",res);
      if (res?.data?.status === "success") {
           showSuccess('Signup Successful.');
      // navigate('/login');
      // Reset the form after successful signup 
     reset()
    }
   
    } catch (error) {
      const msg = error.response?.data?.message || 'Something went wrong';
              showError(msg);
    }
  };

  return (
    <div className={styles.authContainer}>
      <div className={styles.formContainer}>
        <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
          <h1>Signup</h1>

          <input {...register('name')} placeholder="Username" />
          <p>{errors.name?.message}</p>

          <input {...register('email')} placeholder="Email" />
          <p>{errors.email?.message}</p>

          <div className={styles.passwordWrapper}>
            <input
              type={showPassword ? 'text' : 'password'}
              {...register('password')}
              placeholder="Password"
            />
            <span
              onClick={() => setShowPassword((prev) => !prev)}
              className={styles.eyeIcon}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
          <p>{errors.password?.message}</p>          <button className={styles.btn} type="submit">
            Signup
          </button>
          <div className={styles.redirectText}>
            Already have an account?{' '}
            <span onClick={() => navigate('/login')} className={styles.redirectLink}>
              Login
            </span>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SignupForm;
